import {
  POS_ORDER_CREATING,
  POS_ORDER_CREATED,
  POS_ORDER_ERROR,
  POS_ORDERS_LIST,
  POS_ORDER_CLEAR_LAST,
} from "./actionTypes";

const initialState = {
  creating: false,
  error: null,
  lastOrder: null,
  recent: [],
  nextCursor: null,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case POS_ORDER_CREATING:
      return { ...state, creating: true, error: null };

    case POS_ORDER_CREATED:
      return {
        ...state,
        creating: false,
        lastOrder: action.payload,
        recent: [action.payload, ...state.recent].slice(0, 20),
      };

    case POS_ORDER_ERROR:
      return { ...state, creating: false, error: action.payload };

    case POS_ORDERS_LIST:
      return {
        ...state,
        recent: action.payload.append ? [...state.recent, ...action.payload.items] : action.payload.items,
        nextCursor: action.payload.next_cursor || null,
      };

    case POS_ORDER_CLEAR_LAST:
      return { ...state, lastOrder: null };

    default:
      return state;
  }
}
